
import { useState, useEffect } from 'react'
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddTemplate } from "./Modal/AddTemplate";
import { CompetencyList } from "../Common/CompetencyList"
import Swal from 'sweetalert2'
import axios from 'axios'
import { IconButton, Switch, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom'
import { Add, Delete, Edit } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function SurveyTemplate() {
    const authUser = localStorage.getItem("FF-authUser");
    const role = JSON.parse(authUser).role;
    const [show, setShow] = useState(false);
    const [popupType, setPopupType] = useState("Add");
    const [editId, setEditId] = useState(0);
    const [surveys, setSurveys] = useState([]);
    
    useEffect(() => {
        getList();
    }, []);

    const handleAdd = () => {
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }
    const handleEdit = (id) => {
        setEditId(id);
        setPopupType('Edit');
        setShow(true);
      }
    
      const handleSurveyStatus = (e, surveyId) => {
        var status = e.target.checked === true ? '1' : '0';
        axios.put(`api/surveys/updateStatus?id=${surveyId}`, {status}).then(res => {})
        .catch(err => {})
      }
    
      const handleSurveyDelete = (surveyId) => {
        Swal.fire({
          title: 'Are you sure you want to delete?',
          showCancelButton: true,
          confirmButtonColor: '#45a7c4',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) { 
              axios.delete(`/api/surveys/delete?id=${surveyId}`).then((res) =>{
                  if(res.data.success){                             
                      Swal.fire('Deleted!', '', 'success').then(result => { 
                          getList();
                      })
                  }
                  else{
                    Swal.fire(res.data.message, '', 'info')
                  } 
                  
              }).catch((error) => {
                  console.log(error);                     
                  Swal.fire(error.message, '', 'info')           
              });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
      }

    const getList = async () => {
        let apiUrl = "/api/surveys";

        await axios.get(apiUrl).then(function (response) {
            let result = response.data;
            if (result.success) {
                setSurveys(result.data);
            } else {
                // Handle error or set isError state if needed.
            }
        });
    };

    const handleSurveyClone = async (survey) => {
        const { value: newName } = await Swal.fire({
            title: 'Clone Survey Template',
            input: 'text',
            inputLabel: 'Enter new survey name',
            inputValue: survey.name + ' Copy',
            showCancelButton: true,
            confirmButtonText: 'Clone',
            inputValidator: (value) => {
                if (!value) {
                    return 'Survey name is required!';
                }
            }
        });

        if (newName) {
            axios.post('/api/surveys/clone', {
                id: survey.id,
                name: newName
            })
            .then((res) => {
                if (res.data.success) {
                    Swal.fire('Cloned!', '', 'success').then(() => {
                        getList();
                    });
                } else {
                    Swal.fire(res.data.message, '', 'info');
                }
            })
            .catch((err) => {
                console.log(err);
                Swal.fire('Error cloning survey', '', 'error');
            });
        }
    };

    const [accordion, setAccordion] = useState({});
    const [isChange, setIsChange] = useState(false);
    const handleAccordionChange = (key) => {
        if(accordion && accordion[key]){
            accordion[key] = !accordion[key]
        }
        else{
            accordion[key] = true
        }
        setIsChange((prev) => !prev);
        // Get the accordion button element
        const accordionButton = document.querySelector(`[data-key="${key}"]`);
        // Toggle the active class on the accordion button
        accordionButton.classList.toggle('active');
      }
    return(
        <Layout>
            <Header pageTitle={'Competencies'} />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header d-flex justify-content-between align-items-center">                      
                        <h3 className="fw-bold mb-0">Survey Templates</h3>
                        <button type="button" onClick={() => handleAdd()} className="btn btn-primary">
                            <span className="tf-icons bx bx-plus"></span>&nbsp; Add Template
                        </button>
                    </div>

                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                            <div className="col-md mb-4 mb-md-0">

                                <div className="accordion" id="accordionExample1">
                                    {surveys.map((survey) => (
                                        <div className="card accordion-item" key={survey.id}>
                                            <h2 className="accordion-header d-flex align-items-center" id="headingOne">
                                                <button type="button" onClick={() => handleAccordionChange("accordion1"+survey.id)} className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target={"#accordion1"+survey.id} aria-expanded="false" aria-controls={"accordion1"+survey.id}  data-key={"accordion1"+survey.id}>
                                                    {survey.name}
                                                </button>
                                                <div className="d-flex align-items-center">
                                                    {/* <Switch className="Rj-toggle" color="info" onChange={(e) => handleSurveyStatus(e, survey.id)} defaultChecked={survey.status === '1' ? true : false}/> */}
                                                    <Tooltip 
                                                        onClick={() => handleSurveyClone(survey)} 
                                                        title="Clone Survey" 
                                                        size='small' 
                                                        className='icon icon-sm icon-primary'
                                                    >
                                                        <IconButton>
                                                            <ContentCopyIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip onClick={() => handleEdit(survey.id)} title="Edit Survey" size='small' className='icon icon-sm icon-secondary me-3 ms-2'>
                                                        <IconButton>
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip onClick={() => handleSurveyDelete(survey.id)} title="Delete Survey" size='small' className='icon icon-sm icon-primary me-3'>
                                                        <IconButton>
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </h2>

                                            <div id={"accordion1"+survey.id} className={accordion && accordion["accordion1"+survey.id] ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="table-responsive">

                                                        <CompetencyList competencies={survey} getList={getList}/>
                                            
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <AddTemplate type={popupType} show={show} setShow={setShow} getList={getList} editId={editId} setEditId={setEditId}/>
        </Layout>
    )
}